var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2402 10.9435L21.2164 8.96033L21.3481 8.12528C17.7468 4.8392 12.0221 5.21181 8.77566 8.90276C7.87389 9.9279 7.20489 11.206 6.84814 12.5257L7.55596 12.4256L11.5084 11.7716L11.8136 11.4584C13.5717 9.5208 16.5444 9.26013 18.5745 10.9087L19.2402 10.9435Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9189 12.5341C23.4577 10.8958 22.5108 9.42301 21.1942 8.29639L18.3779 11.0129C19.5671 11.9502 20.2446 13.3622 20.2155 14.8431V15.3253C21.5998 15.3253 22.722 16.4078 22.722 17.743C22.722 19.0783 21.5998 20.1336 20.2155 20.1336H15.1955L14.7026 20.6497V23.5495L15.1955 24.0045H20.2155C23.8161 24.0316 26.7577 21.2652 26.7858 17.7922C26.8027 15.6871 25.7267 13.7135 23.9189 12.5341Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2299 24.005H15.3066V20.0006H10.2299C9.86823 20.0005 9.51793 19.924 9.189 19.7759L8.46876 19.9936L6.4224 21.9958L6.24414 22.6772C7.39175 23.531 8.79194 24.0111 10.2299 24.005Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1987 11.3174C6.65893 11.3385 3.80666 14.2225 3.82775 17.7589C3.83954 19.7337 4.7627 21.5927 6.32952 22.7965L9.18818 19.9406C7.94794 19.3808 7.39682 17.9226 7.95715 16.6836C8.5174 15.4445 9.97704 14.8939 11.2171 15.4537C11.7636 15.7003 12.2013 16.1376 12.4481 16.6836L15.3068 13.8276C14.0905 12.239 12.2006 11.3103 10.1987 11.3174Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudIcon);
export default __webpack_public_path__ + "static/media/google-cloud-icon.a9c87565dc69b780cebd9d0e763d1723.svg";
export { ForwardRef as ReactComponent };